import Seo from "../components/Seo";

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service | Zero Harm AI"
        description="Zero Harm AI terms of service — governing use of the Zero Harm AI website, demos, and related services."
        path="/terms"
      />

      <div className="max-w-4xl mx-auto px-4 py-10 text-gray-700">
        <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
          Terms of Service
        </h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: July 8, 2026</p>

        <section className="space-y-5">
          <p>
            These terms govern your use of the Zero Harm AI website, demos, and related
            services. By using our site or contacting us, you agree to these terms.
          </p>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Website and Demo Use
            </h2>
            <p>
              You may use the website and demos for lawful evaluation purposes.
              Do not misuse the services, attempt unauthorized access, overload
              our systems, or submit content that violates applicable law.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              No Professional Advice
            </h2>
            <p>
              Content on this website is provided for general information. It does
              not create a client relationship and should not be treated as legal,
              security, compliance, or professional advice.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Intellectual Property
            </h2>
            <p>
              Zero Harm AI owns or licenses the content, branding, and materials on
              this website. You may not copy, modify, or distribute them without
              permission except as allowed by law.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Disclaimer</h2>
            <p>
              The website and demos are provided as is, without warranties of any
              kind. We do not guarantee uninterrupted availability or error-free
              results.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Contact</h2>
            <p>
              For questions about these terms, contact us at{" "}
              <a
                href="mailto:info@zeroharmai.com"
                className="text-blue-700 underline hover:text-blue-800"
              >
                info@zeroharmai.com
              </a>
              .
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
